import React, { useState } from 'react';
import {
  IconUser,
  IconBuildingStore,
  IconCheck,
  IconSparkles,
  IconRocket,
  IconArrowRight,
} from '@tabler/icons-react';

const UsageTypeSelector = ({ onSelect }) => {
  const [hoveredCard, setHoveredCard] = useState(null);

  return (
    <div className="signup-usage-selector">
      <div className="signup-usage-cards">
        {/* Uso Pessoal */}
        <div
          className={`signup-usage-card ${hoveredCard === 'personal' ? 'signup-usage-card--hover' : ''}`}
          onClick={() => onSelect('personal')}
          onMouseEnter={() => setHoveredCard('personal')}
          onMouseLeave={() => setHoveredCard(null)}
        >
          <div className="signup-usage-card__icon signup-usage-card__icon--personal">
            <IconUser size={28} />
          </div>

          <span className="signup-usage-card__badge signup-usage-card__badge--free">
            <IconSparkles size={14} />
            Teste grátis 7 dias, sem cartão
          </span>

          <h3 className="signup-usage-card__title">Uso Pessoal</h3>
          <p className="signup-usage-card__description">
            Ideal para quem quer experimentar a plataforma, criar agentes para projetos pessoais ou testar antes de escalar.
          </p>

          <ul className="signup-usage-card__features">
            <li><IconCheck size={16} /> Crie seus agentes de IA</li>
            <li><IconCheck size={16} /> Base de clientes e CRM</li>
            <li><IconCheck size={16} /> Playground de testes</li>
            <li><IconCheck size={16} /> Comece grátis, sem cartão</li>
          </ul>

          <div className="signup-usage-card__cta">
            <span>Escolher pessoal</span>
            <IconArrowRight size={18} />
          </div>
        </div>

        {/* Uso Comercial */}
        <div
          className={`signup-usage-card ${hoveredCard === 'commercial' ? 'signup-usage-card--hover' : ''}`}
          onClick={() => onSelect('commercial')}
          onMouseEnter={() => setHoveredCard('commercial')}
          onMouseLeave={() => setHoveredCard(null)}
        >
          <div className="signup-usage-card__icon signup-usage-card__icon--commercial">
            <IconBuildingStore size={28} />
          </div>

          <span className="signup-usage-card__badge signup-usage-card__badge--paid">
            <IconRocket size={14} />
            Teste Grátis sem cartão
          </span>

          <h3 className="signup-usage-card__title">Uso Comercial</h3>
          <p className="signup-usage-card__description">
            Para empresas e agências que precisam de WhatsApp, subcontas, white-label e recursos avançados.
          </p>

          <ul className="signup-usage-card__features">
            <li><IconCheck size={16} /> Tudo do pessoal + WhatsApp</li>
            <li><IconCheck size={16} /> Subcontas e organizações</li>
            <li><IconCheck size={16} /> White-label e domínio próprio</li>
            <li><IconCheck size={16} /> Suporte dedicado</li>
          </ul>

          <div className="signup-usage-card__cta signup-usage-card__cta--commercial">
            <span>Escolher comercial</span>
            <IconArrowRight size={18} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsageTypeSelector;
